/****   request.js   ****/
// 导入axios
import axios from 'axios'
// 使用element-ui Message做消息提醒
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { cat } from 'shelljs';
import router from '@/router';
import store from '@/utils/store.js'; // 导入 Vuex Store
// 是否显示重新登录
export let isRelogin = { show: false };

// const baseURL="https://admin.hdcqyx.cn/"  //短信落地页
 // const baseURL='https://wladmin.bjczjy.cn/' //线上
const baseURL='https://admin.kcjtmr.com/' //线上
//const baseURL='http://8.130.130.39/' //线上
// const baseURL='http://demo.aliwailian.cn/'  //测试
// const baseURL='http://qc9693wh034.vicp.fun/'  //测试

// const baseURL='http://admin.paibaoke.com.cn/' //支付宝在线测试地址
// const baseURL='http://192.168.0.42:80/' //测试王浩
// const baseURL = 'https://test.view.hr.kjjtbz.cn/prod-api'
// const baseURL='http://www.jialianmarket.cn/'  //凤凰
// export const base={
//   url:baseURL
// }
//1. 创建新的axios实例，

const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: baseURL,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 10000
})
// 2.请求拦截器
service.interceptors.request.use(config => {
  //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
  const token = store.getters.getToken;
  config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
  config.headers = {
    'Content-Type':'application/json' ,//配置请求头
    'token':token?token:''
  }
  return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(res => {

  // 未设置状态码则默认成功状态
  const code = res.data.code;
  // 获取错误信息
  const msg =res.data.msg
  // 二进制数据则直接返回
  if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
    return res.data
  }
  if(!code){
    return res.data
  }
  if (code === 401) {
    if (!isRelogin.show) {
      isRelogin.show = true;
      Message({
        message: '登录状态已过期，请重新登录',
        type: 'error',
        duration: 5 * 1000
      })
      let user = null
      let token = null
      store.dispatch('login', { user, token });
      router.replace({path:'/login'})
      // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
      //   confirmButtonText: '重新登录',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }
    // ).then(() => {
    //   console.log("无权限了")
    // }).catch(() => {
    //   isRelogin.show = false;
    // });
  }
    return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
  } else if (code === 500) {
    Message({
      message: msg,
      type: 'error',
      duration:2000
    })
    return Promise.reject(new Error(msg))
  } else if (code !== 200 && code !== 'Success') {
    Notification.error({
      title: msg
    })
    return Promise.reject('error')
  } else {
    return res.data
  }
},
error => {
  let { message } = error;
  if (message == "Network Error") {
    message = "后端接口连接异常";
  }
  else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  }
  else if (message.includes("Request failed with status code")) {
    message = "系统接口" + message.substr(message.length - 3) + "异常";
  }
  Message({
    message: message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
}
)

//4.导入文件
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js